// Gestion centralisée du consentement cookies + Facebook Pixel (RGPD CNIL)
// Le Pixel ne se charge QUE après "Accepter" explicite — sinon rien n'est tracké.

const CONSENT_KEY = 'cp_cookie_consent';  // 'accepted' | 'rejected' | absent
const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;

export const getConsentStatus = () => {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const hasConsent = () => getConsentStatus() === 'accepted';

export const setConsent = (status) => {
  try {
    localStorage.setItem(CONSENT_KEY, status);
  } catch { /* ignore */ }
  if (status === 'accepted') {
    loadFacebookPixel();
  }
  // PostHog (mesure d'audience) suit le même consentement — géré par /analytics.js
  try {
    if (window.cpSetConsent) window.cpSetConsent(status);
  } catch { /* ignore */ }
};

let pixelLoaded = false;

export const loadFacebookPixel = () => {
  if (pixelLoaded) {
    // Déjà chargé — track juste PageView
    if (window.fbq) window.fbq('track', 'PageView');
    return;
  }
  if (!FB_PIXEL_ID) return;
  if (!hasConsent()) return;  // double sécurité

  /* eslint-disable */
  !function(f,b,e,v,n,t,s){
    if(f.fbq)return; n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
    n.queue=[]; t=b.createElement(e); t.async=!0;
    t.src=v; s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s);
  }(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', FB_PIXEL_ID);
  window.fbq('track', 'PageView');
  pixelLoaded = true;
};

// Helper appelé par les pages — n'envoie l'évenement QUE si le pixel est chargé (= consentement donné)
// eventId (optionnel) permet la déduplication avec la Meta Conversions API côté serveur
export const fbTrack = (eventName, params = {}, eventId) => {
  if (!hasConsent()) return;  // pas de consentement = pas de tracking
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      if (eventId) {
        window.fbq('track', eventName, params, { eventID: eventId });
      } else {
        window.fbq('track', eventName, params);
      }
    } catch { /* ignore */ }
  }
};

// Au chargement de l'app : si consentement déjà donné, charge le pixel automatiquement
export const initConsentOnLoad = () => {
  if (hasConsent()) loadFacebookPixel();
};
